import React from "react";

import {
  GameState,
} from "../../../types/GameTypes";
import { Engine } from "../Engine/EngineHook";

export type GameContext = {
  engine: Engine;
};

export const startingGame: GameState = {
  //TODO: fixup refs to emptyGame
  state: "RUNNING",
  nonce: "",
  player: "",
  ballCount: 0,
  guesses: [],
  rays: [],
  score: 0,
  started: 0,
};

/*
 * The context API requires initialized members, so create do-nothing versions. The real stuff is
 * created in the Provider (in this case, Game).
 */
const GameContext = React.createContext<GameContext>({
  engine: {
    arePathsRevealed: () => false,
    getBallCount: () => 0,
    getGuessCount: () => 0,
    getNonce: () => "",
    getPathFor: () => undefined,
    getPenaltyFor: () => 0,
    getRayFor: () => undefined,
    getRevealedStepsFor: () => [],
    getScore: () => 0,
    getState: () => "VOID",
    getTally: () => undefined,
    hasAllGuesses: () => false,
    hasBallAt: () => false,
    hasGuessAt: () => false,
    isComplete: () => false,
    isRunning: () => false,
    isVoid: () => true,
    loadGame: () => {},
    removePaths: () => {},
    shootRayInto: () => {},
    showAllPaths: () => {},
    showPathFor: () => {},
    submitGuesses: () => {},
    toggleGuessAt: () => {},
  },
});

export const GameContextProvider = GameContext.Provider;
export const GameContextConsumer = GameContext.Consumer;

export default GameContext;
